exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.inline[data-v-0e28d537] {\r\n  display: inline-block;\r\n  font-size: 14px;\n}\n.v_input_look_div[data-v-0e28d537] {\r\n  width: 200px !important;\r\n  word-break: break-all;\n}\r\n", ""]);

// exports
